import styled from 'styled-components';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { FONT_STACK, ZIndex } from '../../../../common/styles/constants';
import { propSwitch } from '../../../../common/util/propSwitch';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AutoCompleteDropdown = styled.div`
  border: 1px solid ${ThemeColours.mono300};
  border-radius: 4px;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  z-index: ${ZIndex.OVERLAY};
`;

export const AutoCompleteResult = styled.div`
  ${FONT_STACK}
  background: ${propSwitch('aria-selected', ThemeColours.mono100, ThemeColours.white)};
  cursor: pointer;
  padding: 6px 16px;
  &:not(:first-child) {
    border-top: 1px solid ${ThemeColours.mono300};
  }
`;
